import { useMemo } from 'react';
import { useSystemConfig } from '@/context/SystemConfigContext';
import { useSiteSettings } from '@/hooks/useSiteSettings';
import { DEFAULT_BRANDING, type LogoPlacement } from '@/types/branding';

/** Yerel varsayılanlar — public/branding */
const DEFAULT_LOGO_ON_LIGHT = '/branding/yawas-kebab-logo-on-light-v2.png';
const DEFAULT_LOGO_ON_DARK = '/branding/yawas-kebab-logo-on-dark.png';

export function useBranding() {
  const { config, loading: configLoading, refreshConfig } = useSystemConfig();
  const { get, loading: settingsLoading } = useSiteSettings();
  const loading = configLoading || settingsLoading;

  return useMemo(() => {
    const remoteDark = get('logo_url', '').trim();
    const remoteLight = get('logo_inverse_url', '').trim();

    // Her iki remote logo da tanımlıysa admin override kullan.
    // Sadece logo_url doluysa (eski tek logo) yerel çift logoyu koru — FOUC / yanlış varyant olmasın.
    const useRemotePair = !settingsLoading && !!remoteDark && !!remoteLight;

    const onDark = useRemotePair ? remoteDark : DEFAULT_LOGO_ON_DARK;
    const onLight = useRemotePair ? remoteLight : DEFAULT_LOGO_ON_LIGHT;

    const logoSize = config?.logo_size ?? DEFAULT_BRANDING.logo_size;

    return {
      loading,
      refreshConfig,
      restaurantLogoUrl: onLight,
      logoOnLightUrl: onLight,
      logoOnDarkUrl: onDark,
      logoSize,
      logoPlacement: (config?.logo_placement ?? DEFAULT_BRANDING.logo_placement) as LogoPlacement,
      restaurantName: config?.restaurant_name?.trim() || get('restaurant_name', 'Yawas Kebab') || 'Yawas Kebab',
    };
  }, [config, configLoading, settingsLoading, loading, refreshConfig, get]);
}
